import React from 'react';

const ConfirmDialog = ({ message, onConfirm, onCancel, confirmLabel = 'Conferma', danger = false }) => (
  <div className="fixed inset-0 z-[9998] flex items-center justify-center bg-black/70">
    <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 w-full max-w-sm shadow-2xl">
      <p className="text-white text-sm mb-6 leading-relaxed">{message}</p>
      <div className="flex gap-3 justify-end">
        <button
          onClick={onCancel}
          className="px-4 py-2 text-sm rounded-lg border border-gray-600 text-gray-300 hover:border-white hover:text-white transition"
        >
          Annulla
        </button>
        <button
          onClick={onConfirm}
          className={`px-4 py-2 text-sm rounded-lg font-medium transition ${
            danger
              ? 'bg-red-600 hover:bg-red-500 text-white'
              : 'bg-white hover:bg-gray-100 text-black'
          }`}
        >
          {confirmLabel}
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmDialog;
